import { Button } from '@/components/ui/button'
import { useRef, useState } from 'react'
import type { AnswerInputProps } from '../QuestionRenderer'

export function SignatureInput({ onChange }: AnswerInputProps<string>) {
  const canvasRef = useRef<HTMLCanvasElement | null>(null)
  const [drawing, setDrawing] = useState(false)

  function point(event: React.PointerEvent<HTMLCanvasElement>) {
    const canvas = canvasRef.current
    if (!canvas) return null
    const rect = canvas.getBoundingClientRect()
    return { x: event.clientX - rect.left, y: event.clientY - rect.top }
  }

  function clear() {
    const canvas = canvasRef.current
    const context = canvas?.getContext('2d')
    if (!canvas || !context) return
    context.clearRect(0, 0, canvas.width, canvas.height)
    onChange('')
  }

  return (
    <div className="flex flex-col gap-3">
      <canvas
        ref={canvasRef}
        width={600}
        height={200}
        className="h-52 w-full touch-none rounded-lg border border-slate-200 bg-white"
        onPointerDown={(event) => {
          setDrawing(true)
          const context = canvasRef.current?.getContext('2d')
          const p = point(event)
          if (!context || !p) return
          context.beginPath()
          context.moveTo(p.x, p.y)
        }}
        onPointerMove={(event) => {
          if (!drawing) return
          const context = canvasRef.current?.getContext('2d')
          const p = point(event)
          if (!context || !p) return
          context.lineTo(p.x, p.y)
          context.lineWidth = 2
          context.stroke()
        }}
        onPointerUp={() => {
          setDrawing(false)
          const canvas = canvasRef.current
          if (canvas) onChange(canvas.toDataURL('image/png'))
        }}
      />
      <Button variant="outline" onClick={clear}>
        清除簽名
      </Button>
    </div>
  )
}
